import React, { useCallback, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import LabeledContainer from '../../../../common/LabeledContainer';
import TextInput, { TextInputType } from '../../../../../atoms/TextInput';
import BooksCreateUserConfirmAlert from '../BooksCreateUserConfirmAlert';
import { ErrorType } from '../../../../../domain/entities/Auth';
import { CreateUserQuery } from '../../../../../hooks/api/auth';
import ErrorMessage from '../InputCreateUserErrorMessage';
import { SubmitButton } from '../../../../../atoms/SubmitButton';

interface Props {
  postable: boolean;
  onSubmit: (query: CreateUserQuery) => void;
  errors?: ErrorType[];
}

const InputLogin: React.FC<Props> = (props) => {
  const [lastName, setLastName] = useState<string>('');
  const [firstName, setFirstName] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');

  const submittable = useMemo(() => {
    return lastName && firstName && email && password;
  }, [lastName, firstName, email, password]);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const {
        currentTarget: { name, value },
      } = e;
      switch (name) {
        case 'lastName':
          setLastName(value);
          break;
        case 'firstName':
          setFirstName(value);
          break;
        case 'email':
          setEmail(value);
          break;
        case 'password':
          setPassword(value);
          break;
        default:
          break;
      }
    },
    [setLastName, setFirstName, setEmail, setPassword],
  );

  const handleSubmit = useCallback(async () => {
    props.onSubmit({ lastName, firstName, email, password });
  }, [props, lastName, firstName, email, password]);

  const { postable, errors } = props;
  const intl = useIntl();

  return (
    <div>
      <LabeledContainer
        label={intl.formatMessage({
          id: 'books.formsLabel.lastName',
        })}
        paddingTop={true}
      >
        <TextInput
          type={TextInputType.Text}
          name={'lastName'}
          value={lastName}
          // @ts-expect-error strictFunctionTypes
          onChange={handleChange}
        />
      </LabeledContainer>
      <LabeledContainer
        label={intl.formatMessage({
          id: 'books.formsLabel.firstName',
        })}
        paddingTop={true}
      >
        <TextInput
          type={TextInputType.Text}
          name={'firstName'}
          value={firstName}
          // @ts-expect-error strictFunctionTypes
          onChange={handleChange}
        />
      </LabeledContainer>
      <LabeledContainer
        label={intl.formatMessage({
          id: 'books.formsLabel.email',
        })}
        paddingTop={true}
      >
        <TextInput
          type={TextInputType.Email}
          name={'email'}
          value={email}
          // @ts-expect-error strictFunctionTypes
          onChange={handleChange}
        />
      </LabeledContainer>
      <LabeledContainer
        label={intl.formatMessage({
          id: 'books.formsLabel.password',
        })}
      >
        <TextInput
          type={TextInputType.Password}
          name={'password'}
          value={password}
          // @ts-expect-error strictFunctionTypes
          onChange={handleChange}
          placeholder={intl.formatMessage({
            id: 'books.formsLabel.passwordPlaceholder',
          })}
        />
      </LabeledContainer>
      <ErrorMessage errors={errors} />
      <BooksCreateUserConfirmAlert />
      <SubmitButton
        type="button"
        onClick={handleSubmit}
        value={intl.formatMessage({ id: 'books.submitLabel.userResist' })}
        disabled={!submittable || !postable}
        postable={postable}
      >
        {intl.formatMessage({ id: 'books.submitLabel.userResist' })}
      </SubmitButton>
    </div>
  );
};

export default InputLogin;
